import React, { useEffect } from "react"
import Icon from "../atoms/Icon"
import showModalGallery from "../organisms/ModalGallery"

// if it has children (for instance if itemGalleryLink is used for a <SpecialEvent>) wrap the link around the children
// if not display link text with icon
export default ({ link, className, children, translations }) => {

  const openModalGallery = (e) => {
    e.preventDefault()
    e.returnValue = false
    showModalGallery({ gallery: link.gallery, translations: translations })
  }

  return (

    <a href="#" className={"a-link a-gallery-link" + (className ? " " + className : "")} onClick={ openModalGallery }>

      { !children ? <><span>{ link.linkText }</span> <Icon iconName={ "icon-fullscreen" } className="a-icon a-icon--xs"/></> : children }

    </a>
  )

}